import _ from 'lodash'

class AlertsManagementController {
  constructor($scope, $analytics, alertService, alertCountService, Alert, $uibModal) {
    this.scope = $scope
    this.$uibModal = $uibModal

    this.activeGrid = {
      enableScrollbars: true,
      paginationPageSize: 25,
      enableRowSelection: false,
      enableSelectAll: false,
      multiSelect: false,
      showGridFooter: false,
      rowHeight: 35
    }

    this.alertService = alertService
    this.alertCountService = alertCountService
    this.setupSchema()
    this.alertMessage = ""

    this.$analytics = $analytics
    $scope.deleteHandler = {
      onClick: this.confirmDeleteAlert.bind(this)
    }

    this.queryAlerts()
  }

  queryAlerts() {
    this.alertService.query(
      {},
      this._onQuerySuccess.bind(this)
    )
  }

  _onQuerySuccess(alerts) {
    this.alertCountService.setCurrentCount(alerts)
    this.activeGrid.data = alerts

    this.$analytics.people.set('alert count', alerts.length)

    if(!this.scope.$$phase) {
      this.scope.$apply()
    }
  }

  confirmDeleteAlert(alert) {
    const deleteModalInstance = this.$uibModal.open({
      animation: true,
      controller: 'ConfirmDeleteModalController',
      controllerAs: 'confirmDelete',
      templateUrl: 'confirm-delete-modal.partial.html',
      resolve: { alertTitle: () => alert.title }
    })
    deleteModalInstance.result.then(() => {
      this.deleteAlert(alert.alertId)
    })
  }

  deleteAlert(alertId) {
    this.alertService.deleteAlert(
      alertId,
      this.queryAlerts.bind(this)
    )
  }

  setupSchema() {
    this.activeGrid.columnDefs = [
      { field: 'title',
        displayName: 'Alert Name',
        cellTemplate: '<div class="deep-link"><a href="#/search?{{row.entity.urlEncode()}}">{{row.entity.title}}</a></div>'
      },
      { field: 'legalLocation()',
        displayName: 'Legal' },
      { field: 'entity()',
        displayName: 'Entity' },
      { field: 'createdAt',
        displayName: 'Created At',
        cellFilter: 'date' },
      { field: 'alertId',
        displayName: ' ',
        width: 50,
        cellTemplate: '<div><a href ng-click="grid.appScope.deleteHandler.onClick(row.entity)"><img class="grid-image" src="images/trash.png"></img></a></div>'
      }
    ]
  }
}

AlertsManagementController.$inject = [
  '$scope',
  '$analytics',
  'AlertService',
  'AlertCountService',
  'Alert',
  '$uibModal'
]

export default AlertsManagementController
